import { Component, Inject, OnDestroy, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdminSummary, AdminsApi } from 'src/app/hickory-api';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, finalize, takeUntil, debounceTime, distinctUntilChanged } from 'rxjs';
import { FormControl } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';

export type AdminSelectDialogData = {
  tenantId: number;
};

@Component({
  selector: 'app-admin-select-dialog',
  templateUrl: './admin-select-dialog.component.html',
  styleUrl: './admin-select-dialog.component.scss',
  standalone: false
})
export class AdminSelectDialogComponent implements OnInit, OnDestroy {
  dataSource: MatTableDataSource<AdminSummary> = new MatTableDataSource<AdminSummary>();

  displayedColumns: string[] = ['name'];
  adminsLoading = signal(false);
  page = signal<PageEvent>({ pageIndex: 0, pageSize: 10, length: 0 });

  searchControl = new FormControl('');
  destroy$ = new Subject<void>();

  constructor(
    private readonly dialogRef: MatDialogRef<AdminSelectDialogComponent>,
    private readonly adminsApi: AdminsApi,
    @Inject(MAT_DIALOG_DATA) public data: AdminSelectDialogData,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
  ) {}

  ngOnInit(): void {
    this.getAdmins();
    this.searchControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((search) => {
        this.getAdmins(1, 10, search);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getAdmins(page: number = 1, pageSize: number = 10, search?: string) {
    this.adminsLoading.set(true);
    this.adminsApi
      .getAdminUsers(page, pageSize, null, null, search, null, null, null, null, this.data.tenantId)
      .pipe(
        finalize(() => {
          this.adminsLoading.set(false);
        }),
      )
      .subscribe((admins) => {
        this.dataSource.data = admins.items;
        this.page.set({ pageIndex: page, pageSize: pageSize, length: admins.totalItemCount });
      });
  }

  onPageChange(event: PageEvent) {
    this.getAdmins(event.pageIndex + 1, event.pageSize, this.searchControl.value);
  }

  onSelect(row: AdminSummary) {
    this.dialogRef.close(row);
  }
}
